(function ($) {

  function setPlayEvent(bcVideo) {

    var bcVideoJs = window.videojs || null;

    if (bcVideoJs) {
      bcVideoJs(bcVideo).ready(function () {
        var bcPlayer = this;
        bcPlayer.on('play', function () {
          $('.help-articles .video-js').addClass('help-video-enlarge');
        });
      });
    }

  }

  function ready() {
    if ($('.article-container').length) {
      var bcVideos = document.getElementsByClassName('video-js');

      for (var i = 0; i < bcVideos.length; i++) {
        setPlayEvent(bcVideos.item(i));
      }
    }
  }

  $(document).ready(ready);

}(jQuery));
